<template>
  <div class="amazon-media-multiple-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div ref="dropzone">
          <input type="hidden" :name="options.name" :id="options.name + '-url'" :value="value"/>
          Choose File(s)
        </div>
        <br/>
        <div v-for="(val, index) in value" :key="index">
          Image {{ index + 1 }}
          | <a v-show="val" :href="'https://techcar-dev.s3.amazonaws.com/' + val" target="_blank" style="margin-left: 20px;">Preview</a>
          | <a class="interactive-cursor" @click="deleteImage(val)">Remove</a>
        </div>
        <div class="progress" v-show="isUploading">
          <div class="progress-bar progress-bar-success" role="progressbar" :style="{ width: progress + '%' }"></div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.fd-zone {
  position: relative;
  overflow: hidden;
  // styling
  width: 150px;
  height: 40px;
  position: relative;
  background: #032a63;
  background: -webkit-linear-gradient(top, #246e99, #032a63);
  background: -moz-linear-gradient(top, #246e99, #032a63);
  background: -ms-linear-gradient(top, #246e99, #032a63);
  background: -o-linear-gradient(top, #246e99, #032a63);
  background: linear-gradient(to bottom, #246e99, #032a63);
  -webkit-border-radius: 3;
  -moz-border-radius: 3;
  border-radius: 3px;
  -webkit-box-shadow: 0px 1px 3px #666666;
  -moz-box-shadow: 0px 1px 3px #666666;
  box-shadow: 0px 1px 3px #666666;
  color: #ffffff;
  font-weight: bold;
  font-family: 'Raleway', sans-serif;
  padding: 10px 20px 10px 20px;
  text-decoration: none;
  border: none;
  &:hover {
    background: #032a63;
    text-decoration: none;
    color: #ffffff;
  }
}
.fd-file {
  opacity: 0;
  font-size: 118px;
  position: absolute;
  left: -20px;
  top: -10px;
  z-index: 1;
  padding: 0;
  margin: 0;
  cursor: pointer;
  filter: alpha(opacity=0);
  font-family: sans-serif;
  width: 150px;
  height: 40px;
}
.fd-zone.over {
  background: #032a63;
  text-decoration: none;
  color: #ffffff;
}
</style>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'AmazonMediaMultipleInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      progress: 0,
      isUploading: false,
      isDirty: false,
      isValid: false,
      hasError: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    window.fd.logging = false
    let zone = new window.FileDrop(this.$refs.dropzone, {
      iframe: {
        url: '/api/admin/media-uploader',
        fileParam: 'media',
        callbackParam: 'iframeCallback'
      }
    })
    let $vm = this
    zone.event('send', function (files) {
      $vm.isUploading = true
      files.each(function (file) {
        $vm.hasError = false
        let uploadErrors = []
        let acceptFileTypes = /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
        if (file.type.length && !acceptFileTypes.test(file.type)) {
          uploadErrors.push('Not an accepted file type')
        }
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push('Filesize is too big')
        }
        if (uploadErrors.length > 0) {
          $vm.hasError = uploadErrors.join('\n')
        } else {
          file.event('progress', function (sent, total, xhr, event) {
            $vm.progress = parseInt(sent / total * 100, 10)
          })
          file.event('done', function (xhr) {
            $vm.progress = 0
            $vm.isUploading = false
            let values = $vm.value
            let json = JSON.parse(xhr.responseText)
            values.push(json.key)
            $vm.$emit('input', values)
          })
          file.event('error', function (xhr) {
            uploadErrors.push(xhr.responseText)
            $vm.hasError = uploadErrors.join('\n')
          })
          file.sendTo('/api/admin/media-uploader', {
            extraHeaders: true,
            method: 'POST'
          })
        }
      })
    })
    zone.event('iframeDone', function (json) {
      $vm.progress = 0
      $vm.isUploading = false
      let values = $vm.value
      values.push(json.key)
      $vm.$emit('input', values)
    })
    window.fd.addEvent(window.fd.byID('multiple'), 'change', function (e) {
      zone.multiple(e.currentTarget || e.srcElement.checked)
    })
    this.validate(this.value)
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        if (this.options.required) {
          if (val !== '') this.isValid = true
        } else {
          this.isValid = true
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    deleteImage (image) {
      let values = this.value
      values.splice(values.indexOf(image), 1)
      this.$emit('input', values)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/AmazonMediaMultipleInput.vue